import {UI} from "../../../../stem-core/ui/UIBase";
import {Subscription} from "../../../../client/state/SubscriptionStore.js";
import {ArrayPaginator} from "../../../../stem-core/state/pagination/EndpointPaginator";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable.jsx";
import {Card} from "../../ui/Card.jsx";
import type {AdminUser} from "../../../../client/state/AdminUserStore.js";

interface UserSubscriptionListOptions {
    user?: AdminUser;
}

export class UserSubscriptionList extends UI.Element<UserSubscriptionListOptions> {
    render() {
        const {user} = this.options;
        const paginator = new ArrayPaginator(Subscription.filterBy({
            userId: user.id,
        }));

        const columns = [
            ["Id", (sub: Subscription) => sub.id],
            ["Offer", (sub: Subscription) => sub.recurringOfferId],
            ["Created at", (sub: Subscription) =>sub.createdAt],
            ["Canceled at", (sub: Subscription) => sub.canceledAt],
            ["Status", (sub: Subscription) => sub.status],
        ];

        return (
            <Card title="Subscriptions">
                <SimpleTable columns={columns} paginator={paginator} />
            </Card>
        );
    }
}
